import React from "react";
import {Tooltip} from "@mui/material";

import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";

import AssessmentStatusLabel from "./AssessmentStatusLabel";

export default function AssessmentStatusIcon(props) {

    const {isPassed, tags} = props;

    if (isPassed === null || isPassed === undefined) {
      return <DoneIcon sx={{ m: '-0.4rem' }} fontSize="medium" />;
    }

    const tagList = tags.map(tag => tag.description);

    const label = <AssessmentStatusLabel status={isPassed ? "PASS" : "FAIL"} tagList={tagList} />
    const Icon = isPassed
      ?
      <DoneIcon sx={{m: "-0.4rem"}} fontSize="medium"/>
      :
      <ClearIcon sx={{m: "-0.4rem"}} fontSize="medium"/>;

    return <Tooltip title={label}>{Icon}</Tooltip>;
}